module.exports = __webpack_public_path__ + "static/media/09-img.aa529945.jpg";